import { ApplicationState } from '@store/types'
import { TrackRefinRequest } from '@services/postTrackingRefinService'
import { StepRefin, TipoEmprestimo } from '@utils/enums'
import { removeMask } from '@utils/masks'

const PRODUTO_LABELS: Record<number, string> = {
  3: 'REFINANCIAMENTO SIAPE',
  6: 'REFINANCIAMENTO INSS',
  47: 'REFINANCIAMENTO CTPS',
}

const getProduto = (codigoProduto: number): string =>
  PRODUTO_LABELS[codigoProduto] ?? 'REFINANCIAMENTO'

const getFamilia = (convenioCodigo: number): string =>
  convenioCodigo === 47 ? 'privado' : 'publico'

const getNumeroContrato = (contratosSelecionados?: { numeroContrato: string }[]): string =>
  contratosSelecionados?.map((c) => c.numeroContrato).toString() ?? ''

const getVencimentoProxParcela = (
  listaContratos?: Array<{
    listMatricula?: Array<{
      listContrato?: Array<{ vencimentoProximaParcela?: string }>
    }>
  }>,
): string => {
  const result = listaContratos
    ?.map((contrato) =>
      contrato?.listMatricula
        ?.map((c) => c?.listContrato?.map((lc) => lc?.vencimentoProximaParcela).toString())
        .toString(),
    )
    .toString()
  return result ?? ''
}

const getOrgaoDesc = (
  contratosSelecionados?: { orgaoDesc?: string }[],
  fallback?: string,
): string => contratosSelecionados?.[0]?.orgaoDesc ?? fallback ?? ''

const getDocumento = (cpfDadosPessoais?: string, cpfSession?: string): string =>
  cpfDadosPessoais ? removeMask(cpfDadosPessoais) : removeMask(cpfSession ?? '') ?? ''

export const buildTrackingRequest = (
  { ui, refinanciamento, session }: ApplicationState,
  step: StepRefin | string,
  extraData?: {
    screen_name?: string
    section?: string
    scenario?: string
  },
): TrackRefinRequest => {
  const { simulacao, contratos, dadosPessoais } = refinanciamento
  const { parcelaAtual } = simulacao
  const sessionId = session.sessionId ?? ''
  const origem = ui?.navigation?.origem ?? ''
  const debtBalance = simulacao.debtBalance ?? 0

  const trackingRequest: TrackRefinRequest = {
    clientId: sessionId,
    step,
    eventType: 'SIMULADOR_REFINANCIAMENTO',
    quantidadeParcelas: simulacao.totalParcelas ?? 0,
    saldoDevedorPreRefin: debtBalance,
    sessionId,
    iof: parcelaAtual.amountIOF ?? 0,
    taxaJuros: parcelaAtual.monthlyNominalRate ?? 0,
    valorEmprestimo: parcelaAtual.requestedAmount ?? 0,
    valorLiberado: parcelaAtual.availableAmount ?? 0,
    valorTotalSolicitado: parcelaAtual.requestedAmount ?? 0,
    valorTotalRefinanciado: debtBalance,
    valorQuitacao: debtBalance,
    valorCET: parcelaAtual.cETAa ?? 0,
    custoEfetivoTotal: parcelaAtual.cETAa ?? 0,
    taxaAtual: parcelaAtual.cETAm ?? 0,
    valorProximaParcela: parcelaAtual.installmentAmount ?? 0,
    numeroContrato: getNumeroContrato(contratos.contratosSelecionados),
    vencimentoProxParcela: getVencimentoProxParcela(contratos.listaContratos),
    origem,
    produto: getProduto(contratos.codigoProduto),
    convenioId: contratos.convenioCodigo,
    documento: getDocumento(dadosPessoais.cpfDadosPessoais, session.cpfSession),
    convenio:
      contratos.contratosSelecionados?.[0]?.convenioDesc ?? contratos.convenioSelecionado ?? '',
    familia: getFamilia(contratos.convenioCodigo),
    autarquiaEmpresa: getOrgaoDesc(contratos.contratosSelecionados, contratos.orgaoSelecionado),
    creditoProtegido: simulacao.simulacaoSelecionada === TipoEmprestimo.CREDITO_PROTEGIDO,
    descricaoOrgao: getOrgaoDesc(contratos.contratosSelecionados, contratos.orgaoSelecionado),
  }

  if (extraData?.screen_name) trackingRequest.screen_name = extraData.screen_name
  if (extraData?.section) trackingRequest.section = extraData.section
  if (extraData?.scenario) trackingRequest.scenario = extraData.scenario

  return trackingRequest
}
